'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_axios@0.18.0@axios/lib/cancel/isCancel.js
// module id = K3AH
// module chunks = 11